import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIntegrations = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "currentColor",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M8.804 2.3a1.51 1.51 0 0 0-1.508 1.514v.5H4.31v2.943l-.46.037c-.522.043-.905.229-1.155.481-.247.25-.394.597-.394 1.029 0 .842.651 1.514 1.509 1.514h.5V13.3h2.035a2.486 2.486 0 0 1 2.46-2.014 2.52 2.52 0 0 1 2.458 2.014H13.3v-2.032a2.517 2.517 0 0 1-2.014-2.464c0-1.211.866-2.226 2.014-2.458V4.314h-2.988v-.5c0-.836-.68-1.514-1.508-1.514ZM6.346 3.314A2.51 2.51 0 0 1 8.804 1.3c1.212 0 2.227.866 2.458 2.014H14.3v3.982h-.5c-.836 0-1.514.68-1.514 1.508 0 .835.679 1.514 1.514 1.514h.5V14.3h-3.988v-.5a1.52 1.52 0 0 0-1.508-1.514A1.49 1.49 0 0 0 7.296 13.8v.5H3.31v-3.03A2.493 2.493 0 0 1 1.3 8.804c0-.673.236-1.28.683-1.732.347-.35.801-.59 1.326-.706V3.314h3.037Z",
		clipRule: "evenodd"
	})
});
export default SvgIntegrations;
